import {Network} from "../../../network/Network";
import {ProductType} from "../../../models/product/ProductType";
import {INetworkComponent} from "../../../network/types/INetworkComponent";
import {HttpStatus} from "../../../network/status/HttpStatus";
import {WebSocketCommunityEventName} from "../../../network/socket/names/WebSocketCommunityEventName";
import {ICommunityGeneratePromptOutgoingModel} from "../../../models/community/writingStyle/ICommunityGeneratePromptOutgoingModel";
import {ICommunityGeneratePromptIncomingModel} from "../../../models/community/writingStyle/ICommunityGeneratePromptIncomingModel";
import {arrayRemove} from "../../../sedestral/framework/utilities/ArrayRemove";

export class CommunityWritingStyleService {

    public static styleEvents: ((event: ICommunityGeneratePromptIncomingModel) => void)[] = [];

    public static dispose(): void {
        this.styleEvents = [];
    }

    public static init(): void {
        Network.on(ProductType.COMMUNITY, WebSocketCommunityEventName.COMMUNITY_WRITING_STYLE_UPDATE, (data: ICommunityGeneratePromptIncomingModel) => {
            this.styleEvents.forEach(value => value(data));
        });
    }

    /**
     * websocket
     */

    static onWritingStyle(component: INetworkComponent, func: (event: ICommunityGeneratePromptIncomingModel) => void) {
        this.styleEvents.push(func);
        component.onRemove(() => arrayRemove(this.styleEvents, func));
    }

    public static async generate(outgoing: ICommunityGeneratePromptOutgoingModel, component?: INetworkComponent): Promise<boolean> {
        let request = await Network.postJson(ProductType.COMMUNITY, `/community/writingStyle/generate`, outgoing, component);
        return request.status == HttpStatus.ACCEPTED;
    }

    public static async regenerate(communityId: string, type: string, component?: INetworkComponent): Promise<boolean> {
        let request = await Network.postJson(ProductType.COMMUNITY, `/community/writingStyle/regenerate`, {communityId, type}, component);
        return request.status == HttpStatus.ACCEPTED;
    }
}
